/* eslint-disable max-len */
import { yupResolver } from '@hookform/resolvers/yup';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { MSG, PAYMENT_TYPE, PURCHASE_STATUS, SYSTEM_PATH } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import yup from '../../core/utils/yupValidate';
import classNames from 'classnames';
import { FormatNumber, FullPagination } from '../../components';
import './style.scss'
import moment from 'moment';
import { io } from 'socket.io-client';
import { URL_SOCKET_PURCHASE } from '../../core/utils/socket';
// import ListImageCard from '/list_card.svg'




const PurchaseHistory = observer(() => {

    // other
    const navigate = useNavigate();

    // store
    const { 
        modalStore: { show, hide, openAlert }, 
        transactionStore: { listTransaction, getAllTransaction, setAttrObservable, paging },
        authStore: { accountInfo }} = useStore();

    //state
    const { register, getValues, watch, handleSubmit } = useForm({
        mode: 'onChange', defaultValues: {
            // price: '0',
            // sort: '0'
        }
    });

    const purchaseStatus = (transaction) => {
        return Object.keys(PURCHASE_STATUS).filter(e => PURCHASE_STATUS[e].value === transaction)?.[0] ?? null;
    }


    //lifecycle
    useEffect(() => {
        onFetchPurchaseHistoryList({ page: 1, size: 10, type: PAYMENT_TYPE.HOLDER });
        return () => {
            setAttrObservable('listTransaction', []);
        }
    }, [])

    useEffect(() => {
        const socketPurchase = io(URL_SOCKET_PURCHASE);

        socketPurchase.on('connect', () => {
            socketPurchase.emit('user-connected', {accountId: accountInfo?.id})
        })

        socketPurchase.on('accept-purchase-status', () => {
            onSearch(true);
        });

        return () => {
            socketPurchase.off('accept-purchase-status');
            socketPurchase.disconnect();
        };
    }, []);

    // function

    const onSearch = (disableLoading) => {
        onFetchPurchaseHistoryList({ page: 1, size: 10, type: PAYMENT_TYPE.HOLDER }, disableLoading);
    }


    const onFetchPurchaseHistoryList = async (payload, disableLoading) => {
        const { transactionCode, transactionStatus } = getValues();
        await getAllTransaction({
            transactionCode: transactionCode || null,
            transactionStatus: transactionStatus || null,
            type: PAYMENT_TYPE.HOLDER,
            ...payload
        }, () => {}, disableLoading);
    }



    const onPageChange = (page) => {
        onFetchPurchaseHistoryList({ page });
    }


    return (
        <div className='list-card-screen  list-purchase-history-screen pd-20 border-radius-10 bg-cs-container  list-purchase-history-responsive min-height-820 payment-screen'>
            <div className='mg-t-20 fs-heading-large font-semi-bold '>Holder追加取引履歴</div>
            <div className='w-full mg-t-32'>
                <form onSubmit={handleSubmit(onSearch)} >
                    <div className='d-flex align-items-center justify-content-between flex-gap-80 flex-wrap list-card-list-select'>

                        <div className='d-flex align-items-center flex-gap-10 list-card-list-select-item  col-6-select  flex-wrap '>
                            <label className='col-2' >取引No</label >
                            <input {...register('transactionCode')} className='col-10-custom select-custom input-custom'>
                            </input>
                        </div>
                        <div className='d-flex align-items-center flex-gap-10 list-card-list-select-item  col-6-select  flex-wrap '>
                            <label className='col-2'>支払い状態</label >
                            <select {...register('transactionStatus')} className='col-10-custom select-custom height-45'>
                                <option value={''}>すべて</option>
                                {
                                    // eslint-disable-next-line max-len
                                    Object.keys(PURCHASE_STATUS).map(e => <option key={PURCHASE_STATUS[e].value} value={PURCHASE_STATUS[e].value} >{PURCHASE_STATUS[e].label}</option>)
                                }
                            </select>
                        </div>
                    </div>
                    <button type='submit' className='btn btn-bg-cs-1 min-width-150 d-block mx-auto mg-tb-40' >検索</button>
                </form>
                <div className='row mg-t-16 list-item'>
                    {listTransaction?.length > 0 ? listTransaction.map((item) => (
                        // eslint-disable-next-line max-len
                        <div key={item.id} className='d-flex align-items-center justify-content-center col-lg-6 col-sm-12 flex-wrap mg-b-24 history-purchase-card align-self-start'>
                            <div className='list-card-item row py-4'>
                                <div className='col-4 card-detail-image d-flex  align-items-center '>
                                    <img className='w-100 max-width-190' src='https://zept-rase.s3.ap-northeast-1.amazonaws.com/mexc/card/Card_holder_block.png'></img>
                                </div>
                                <div className='col-8 history-purchase-card-label '>
                                    <div className='mg-b-10 pd-t-15 fs-heading-normal font-semi-bold'>{item?.code}</div>
                                    <div className='mg-b-10 fs-label font-semi-bold'>Holder追加料</div>
                                    <div className='d-inline-grid align-items-center justify-content-center'>
                                        <div className='d-flex align-items-center history-purchase-card-label-item mg-b-10'>
                                            <div className='width-120 history-purchase-card-label-width text-color-cs-9 text-left'>Holder総枠数</div>
                                            <div className='w-full'>{item?.numberHolder}</div>
                                        </div>
                                        <div className='d-flex align-items-center history-purchase-card-label-item mg-b-10'>
                                            <div className='width-120 history-purchase-card-label-width text-color-cs-9 text-left'>支払総額:</div>
                                            {item?.totalPayment > 0 ? <div className='text-color-cs-14 w-full'>
                                                <FormatNumber className='text-color-cs-14' statusDisplay='text' value={item?.totalPayment} suffix=' 円' /> </div> : ''}
                                        </div>
                                        <div className='d-flex align-items-center  history-purchase-card-label-item mg-b-10'>
                                            <div className='width-120 history-purchase-card-label-width text-color-cs-9 text-left' >作成日:</div>
                                            <div className='w-full'>{item?.createdAt ? moment(item?.createdAt).format('YYYY/MM/DD HH:mm:ss') : ''}</div>
                                        </div>
                                        <div className='d-flex align-items-center  history-purchase-card-label-item '>
                                            <div className='width-120 history-purchase-card-label-width text-color-cs-9 text-left' >支払日:</div>
                                            <div className='w-full'>{item?.transactionDate ? moment(item?.transactionDate).format('YYYY/MM/DD HH:mm:ss') : ''}</div>
                                        </div>
                                    </div>
                                </div>
                                <Link to={`/purchase-holder-detail/${item?.id}`} className='d-flex justify-content-end align-items-center flex-gap-5 text-color-cs-14 mg-t-20'>
                                    <img className='width-20' src='/images/icon_detail.svg'></img>
                                    <div className='fs-default text-color-cs-14 text-center border-bottom'>詳細を見る</div>
                                </Link>
                            </div>
                            <div className='notification d-flex justify-content-center align-items-center width-120 height-20
                              border-radius-10' style={{ 'backgroundColor': PURCHASE_STATUS[purchaseStatus(item?.status)]?.color }} >
                                <div> {purchaseStatus(item?.status) && PURCHASE_STATUS[purchaseStatus(item?.status)]?.label}</div>
                            </div>
                        </div>

                    )) : <div className='d-flex align-items-center justify-content-center mg-t-10 '>
                        <span className='fs-heading-normal font-bold text-color-cs-1'>{MSG['inform.no_data']}</span>
                    </div>}

                </div>

            </div>
            <div className='d-flex align-items-center justify-content-center '>
                <FullPagination siblingCount={0}
                    totalRecords={paging.totalRecord}
                    currentPage={paging.page}
                    pageSize={paging.size}
                    onPageChange={onPageChange}
                    previousLabel="«"
                    nextLabel="»" />
            </div>
        </div>
    )
})

export default PurchaseHistory;